import React, { useEffect } from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ThankYouPage() {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);
  return <div className="bg-white rounded-lg shadow-lg p-8 text-center backdrop-blur-sm bg-opacity-70" data-id="element-165">
      <div className="flex justify-center mb-6" data-id="element-166">
        <div className="w-20 h-20 rounded-full bg-[#C8FAF1] flex items-center justify-center animate-pulse" data-id="element-167">
          <CheckCircleIcon size={48} className="text-[#052858]" data-id="element-168" />
        </div>
      </div>
      <h2 className="text-2xl font-bold text-[#052858] mb-4" data-id="element-169">
        Bedankt voor uw inzending!
      </h2>
      <p className="text-gray-600 mb-6" data-id="element-170">
        Uw informatie is succesvol ontvangen. Ons team zal deze gegevens
        gebruiken voor de installatie van uw KRNWTR+ waterkraan systeem.
      </p>
      <div className="p-4 bg-[#C8FAF1] bg-opacity-30 rounded-lg inline-block" data-id="element-171">
        <p className="text-[#052858] font-medium" data-id="element-172">
          Heeft u nog vragen? Neem contact op met ons team:
        </p>
        <p className="text-gray-600 mt-2" data-id="element-173">
          <a href="mailto:info@krnwtr.nl" className="text-[#01AAFF] hover:underline" data-id="element-174">
            info@krnwtr.nl
          </a>
        </p>
      </div>
    </div>;
}